import '../../../common/appContext/spec/appContextSpec.js';
import '../../../common/appContext/spec/consoleLoggerSpec.js';
import '../../../common/appContext/spec/eventBusSpec.js';

import '../../../common/appContext/spec/i18nSpec.js';
import '../../../common/appContext/spec/sharedStateSpec.js';
import '../../../common/spec/miscSpec.js';
import '../../../common/spec/mutexHelperSpec.js';
import '../../../common/spec/providerSpec.js';
import './appContextSpec.js';

import { startTest } from '../../test/util.js';

startTest();
